import React, { useState } from "react";
import { QUIZ_CONFIRM_TYPES } from "../../lib/quizSeason";

function QuizBadge({ count }) {
  if (!count || count === 0) {
    return <span className="lb-none">—</span>;
  }
  return (
    <span className="quiz-badge">
      {count}/2{count >= 2 ? " ✓" : ""}
    </span>
  );
}

export default function QuizSeasonCell({
  effectiveCount = 0,
  currentCount = 0,
  staleCount = 0,
  pending = false,
  onConfirm,
  disabled = false,
  compact = false,
  saving = false,
}) {
  const [open, setOpen] = useState(false);
  const [sameCount, setSameCount] = useState("1");

  const maxSame = Math.min(staleCount, Math.max(0, 2 - currentCount));

  const close = () => {
    setOpen(false);
    setSameCount("1");
  };

  const runConfirm = (payload) => {
    onConfirm?.(payload);
    close();
  };

  if (!pending) {
    return <QuizBadge count={effectiveCount} />;
  }

  if (!open) {
    return (
      <div className={`quiz-cell${compact ? " quiz-cell-compact" : ""}`}>
        <QuizBadge count={effectiveCount} />
        <button
          type="button"
          className="quiz-fix-btn"
          disabled={disabled || saving}
          onClick={() => setOpen(true)}
        >
          {saving ? "…" : `${staleCount} old`}
        </button>
      </div>
    );
  }

  return (
    <div className={`quiz-cell quiz-cell-open${compact ? " quiz-cell-compact" : ""}`}>
      <QuizBadge count={effectiveCount} />
      <div className="quiz-fix-panel">
        <button
          type="button"
          className="quiz-fix-action"
          disabled={disabled || saving}
          onClick={() =>
            runConfirm({
              confirmType: QUIZ_CONFIRM_TYPES.NOT_RETURNING,
              returningTeams: 0,
            })
          }
        >
          {staleCount > 1 ? "Remove both" : "Remove"}
        </button>
        {maxSame > 0 && (
          <>
            <select
              className="quiz-fix-select"
              value={sameCount}
              disabled={disabled || saving}
              onChange={(e) => setSameCount(e.target.value)}
              aria-label="Same teams count"
            >
              {Array.from({ length: maxSame }, (_, i) => i + 1).map((n) => (
                <option key={n} value={String(n)}>
                  {n} same
                </option>
              ))}
            </select>
            <button
              type="button"
              className="quiz-fix-action quiz-fix-action-primary"
              disabled={disabled || saving}
              onClick={() =>
                runConfirm({
                  confirmType: QUIZ_CONFIRM_TYPES.SAME_RETURNING,
                  returningTeams: Number(sameCount),
                })
              }
            >
              Same teams
            </button>
          </>
        )}
        <button
          type="button"
          className="quiz-fix-action"
          disabled={disabled || saving}
          onClick={() =>
            runConfirm({
              confirmType: QUIZ_CONFIRM_TYPES.NEW_TEAMS,
              returningTeams: 0,
            })
          }
        >
          New teams
        </button>
        <button
          type="button"
          className="quiz-fix-cancel"
          disabled={saving}
          onClick={close}
        >
          ×
        </button>
      </div>
    </div>
  );
}
